import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet';
import 'react-toastify/dist/ReactToastify.css';
import EmailViewer from './components/EmailViewer';
import Navbar from './components/Navbar';
import ErrorBoundary from './components/ErrorBoundary';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import DonationSidebar from './components/DonationSidebar';
import Blog from './components/pages/Blog';
import FAQ from './components/pages/FAQ';
import Privacy from './components/pages/Privacy';
import NotFound from './components/pages/NotFound';
import SchemaMarkup from './schema';
import CookieConsent from './components/CookieConsent';
import { CountryProvider } from './components/CountryContext';
import './styles/main.css';
import './styles/ads.css';
import './styles/Blog.css';
import WhyChooseQuickInbox from './components/pages/BlogPosts/WhyChooseQuickInbox';
import WhatIsTemporaryEmail from './components/pages/BlogPosts/WhatIsTemporaryEmail';
import HowToCreateTemporaryEmail from './components/pages/BlogPosts/HowToCreateTemporaryEmail';
import AnonymousOnlineWithTempEmail from './components/pages/BlogPosts/AnonymousOnlineWithTempEmail';
import BestTemporaryEmailServices from './components/pages/BlogPosts/BestTemporaryEmailServices';
import BusinessesAndTemporaryEmails from './components/pages/BlogPosts/BusinessesAndTemporaryEmails';
import TemporaryEmailCybersecurity from './components/pages/BlogPosts/TemporaryEmailCybersecurity';
import EmailTestingForDevelopers from './components/pages/BlogPosts/EmailTestingForDevelopers';

function App() {
  const [isDonationSidebarOpen, setIsDonationSidebarOpen] = useState(false);

  const toggleDonationSidebar = () => {
    setIsDonationSidebarOpen(!isDonationSidebarOpen);
  };

  return (
    <ErrorBoundary>
      <Helmet>
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="og:site_name" content="Quick Inbox" />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <SchemaMarkup />
      <Router>
        <CountryProvider>
          <ScrollToTop />
          <div className="App">
            <Navbar />
            <main className="container">
              <Routes>
                {/* Country-specific routes */}
                <Route path="/:country" element={<EmailViewer />} />
                <Route path="/:country/blog" element={<Blog />} />
                <Route path="/:country/faq" element={<FAQ />} />
                <Route path="/:country/privacy" element={<Privacy />} />
                
                {/* Blog post routes with country parameter */}
                <Route path="/:country/blog/why-choose-quick-inbox" element={<WhyChooseQuickInbox />} />
                <Route path="/:country/blog/what-is-temporary-disposable-email" element={<WhatIsTemporaryEmail />} />
                <Route path="/:country/blog/how-to-create-temporary-email" element={<HowToCreateTemporaryEmail />} />
                <Route path="/:country/blog/anonymous-online-with-temp-email" element={<AnonymousOnlineWithTempEmail />} />
                <Route path="/:country/blog/best-temporary-email-services" element={<BestTemporaryEmailServices />} />
                <Route path="/:country/blog/businesses-and-temporary-emails" element={<BusinessesAndTemporaryEmails />} />
                <Route path="/:country/blog/temporary-email-cybersecurity" element={<TemporaryEmailCybersecurity />} />
                <Route path="/:country/blog/email-testing-for-developers" element={<EmailTestingForDevelopers />} />
                
                {/* Default routes (without country) */}
                <Route path="/" element={<EmailViewer />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/privacy" element={<Privacy />} />
                
                {/* Blog post routes without country */}
                <Route path="/blog/why-choose-quick-inbox" element={<WhyChooseQuickInbox />} />
                <Route path="/blog/what-is-temporary-disposable-email" element={<WhatIsTemporaryEmail />} />
                <Route path="/blog/how-to-create-temporary-email" element={<HowToCreateTemporaryEmail />} />
                <Route path="/blog/anonymous-online-with-temp-email" element={<AnonymousOnlineWithTempEmail />} />
                <Route path="/blog/best-temporary-email-services" element={<BestTemporaryEmailServices />} />
                <Route path="/blog/businesses-and-temporary-emails" element={<BusinessesAndTemporaryEmails />} />
                <Route path="/blog/temporary-email-cybersecurity" element={<TemporaryEmailCybersecurity />} />
                <Route path="/blog/email-testing-for-developers" element={<EmailTestingForDevelopers />} />
                
                {/* 404 route */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer toggleDonationSidebar={toggleDonationSidebar} />
            <DonationSidebar 
              isOpen={isDonationSidebarOpen}
              onClose={() => setIsDonationSidebarOpen(false)}
            />
            <CookieConsent />
            <ToastContainer 
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </CountryProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App; 